import type { Ref } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { CommandPalette, type CommandPaletteHandle } from "./CommandPalette";
import {
  type CommandPaletteDataProps,
  commandPaletteDataSchema,
} from "./CommandPalette.schema";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "command-palette": {
      props: CommandPaletteDataProps;
      handle: CommandPaletteHandle;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-command-palette": HTMLElement & CommandPaletteHandle;
  }
}

export function RWCCommandPalette({
  ref,
}: CommandPaletteDataProps & { ref?: Ref<CommandPaletteHandle> }) {
  return <CommandPalette ref={ref} />;
}

componentManager.register(
  rwc("command-palette", {
    component: RWCCommandPalette,
    dataSchema: commandPaletteDataSchema,
  }),
);
